import { combineReducers } from 'redux';

import {
	loginAuthReducers,
	datepikerReducers,
	lineReducers,
	plantsReducer,
	shopReducers,
	userReducers,
	responseHandlerReducers,
	updatedDataReducers,
	reuploadedDataReducers,
	darftedDataReducers
} from 'src/redux/features';

export const Reducers = combineReducers({
	loginAuth: loginAuthReducers,
	allPlants: plantsReducer,
	allshops: shopReducers,
	allLine: lineReducers,
	filterDates: datepikerReducers,
	user: userReducers,
	onResponse: responseHandlerReducers,
	updatedData: updatedDataReducers,
	reuploadData: reuploadedDataReducers,
	draftedData: darftedDataReducers
});
